<flow-chart-container [title]="title | translate" [hasData]="dataPerDay?.length > 0">
  <ng-container slot="compare">
    <div class="flex">
      <span *ngIf="startDate === endDate">{{startDate}}</span>
      <span *ngIf="startDate !== endDate">{{startDate}} - {{endDate}}</span>
    </div>
  </ng-container>
  <div>
    <canvas class="m-0" [data]="barChartData" [options]="barChartOptions" baseChart height="50vh"></canvas>
  </div>
</flow-chart-container>
